import { SwapContainer } from '@/features/swap/SwapContainer'
import { Token } from '@/domain/types/Token'

export function SwapView({ token }: { token: Token }) {
  return (
    <div className="-mt-2">
      <SwapContainer isModal simplified token={token} />
    </div>
  )
}
